<template>
  <section class="employ-service">
    <header class="header-top-content">
      <div>
        <div class="img-bc" :style="`background-image:url(${topUrl})` | isWebp(topUrl)">
          <div class="header-btn-content">
            <div class="header-title">开放平台</div>
            <div class="header-desc">通过灵活用工API技术对接，向 “弹性用工企业管理” 转型</div>
            <div class="header-btn"
                 @click="scrollToApply"
                 style="cursor: pointer;"
            >
              申请试用
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main style="padding-bottom: 30px">
      <div class="color-f7faff ">
        <div class="capacity">
          <GImage class="bg-capacity" gSrc="page/homePage/views/index/openPlatform/images/bg-title.png"></GImage>
          <sectionTitle align="center" color="black"
                        style="margin-bottom: 60px;margin-top: 60px">
            <template #primary>全平台开放能力</template>
            <template #minor>Platform capabilities</template>
          </sectionTitle>
          <GImage class="bg-capacity-item" gSrc="page/homePage/views/index/openPlatform/images/bg-capacity-item.png"></GImage>
        </div>
      </div>
      <div class="strength">
        <sectionTitle align="space-between" color="black"
                      style="margin-bottom: 60px;">
          <template #primary>团队实力</template>
          <template #minor>Team strength</template>
          <template #rightText>Strength</template>
        </sectionTitle>
        <div class="item-box">
          <div class="module_1_item" style="margin: 0">
            <GImage gSrc="page/homePage/views/index/openPlatform/images/bg-strength-1.jpg"></GImage>
            <div class="module_2_item_title">技术实力过硬</div>
            <div class="module_2_item_text">产研团队核心骨干主要来自于腾讯、华为、新浪等互联网科技公司</div>
          </div>
          <div class="module_1_item">
            <GImage gSrc="page/homePage/views/index/openPlatform/images/bg-strength-2.jpg"></GImage>
            <div class="module_2_item_title">服务安全稳定</div>
            <div class="module_2_item_text">阿里云安骑士百万级主机，稳定安全防护</div>
          </div>
          <div class="module_1_item">
            <GImage gSrc="page/homePage/views/index/openPlatform/images/bg-strength-3.jpg"></GImage>
            <div class="module_2_item_title">开发者友好</div>
            <div class="module_2_item_text">开发者可通过查看API接口文档自主完成对接，效率极高</div>
          </div>
          <div class="module_1_item">
            <GImage gSrc="page/homePage/views/index/openPlatform/images/bg-strength-4.jpg"></GImage>
            <div class="module_2_item_title">极速售后响应</div>
            <div class="module_2_item_text">提供7*24小时专业及时的售后服务</div>
          </div>
        </div>
      </div>
      <div class="module_2_item2 color-f7faff">
        <sectionTitle align="space-between" color="black"
                      style="margin-bottom: 60px;">
          <template #primary>适用场景</template>
          <template #minor>Applicable scenarios</template>
          <template #rightText>Scenarios</template>
        </sectionTitle>
        <div class="item2-bg">
          <GImage gSrc="page/homePage/views/index/openPlatform/images/bg-scenarios.jpg"></GImage>
        </div>
      </div>
      <div class="service-case">
        <sectionTitle
          align="space-between"
          color="black"
          style="margin-bottom: 65px"
        >
          <template #primary>服务案例</template>
          <template #minor>Service case</template>
          <template #rightText>Case</template>
        </sectionTitle>
        <div class="section-5-content">
          <div class="industry-solutions-item-box">
            <div class="solutions-titles">
              <div
                class="title-items"
                :class="{'selected-title' : index === selectSolutionsIndex}"
                v-for="(item,index) in industrySolutionsList"
                :key="index"
                @mouseover="selectItemHandle(index)"
              >
                {{item.title}}
              </div>
            </div>
            <div v-for="(item,index) in industrySolutionsList" :key="index" >
              <div class="solutions-item" :class="{'item-7' : index === 6}"  v-if="index === selectSolutionsIndex">
                <div class="item-left">
                  <img :src="item.imgUrl | isWebp" alt="">
                </div>
                <div class="item-right">
                  <div class="right-top">
                    <div class="right-title">服务场景</div>
                    <div class="right-desc" v-html="item.question"></div>
                  </div>
                  <div class="right-top">
                    <div class="right-title">解决方案</div>
                    <div class="right-desc" v-html="item.answer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="module_2_item3 color-f7faff">
        <sectionTitle align="space-between" color="black"
                      style="margin-bottom: 60px">
          <template #primary>合作流程</template>
          <template #minor>Cooperation process</template>
          <template #rightText>Process</template>
        </sectionTitle>
        <div class="flow-path">
          <div class="flow-path-item" style="margin-left: 0">
            <div class="flow-path-icon icon1">
              <div class="flow-path-item-circle">
                <div class="circle-off"></div>
                <div class="circle-on"></div>
              </div>
            </div>
            <div class="flow-path-item-title">意向沟通</div>
          </div>
          <div class="flow-path-item">
            <div class="flow-path-icon icon2">
              <div class="flow-path-item-circle">
                <div class="circle-off"></div>
                <div class="circle-on"></div>
              </div>
            </div>
            <div class="flow-path-item-title">申请试用</div>
            <div class="flow-path-item-circle">
              <div class="circle-off"></div>
              <div class="circle-on"></div>
            </div>
          </div>
          <div class="flow-path-item">
            <div class="flow-path-icon icon3">
              <div class="flow-path-item-circle">
                <div class="circle-off"></div>
                <div class="circle-on"></div>
              </div>
            </div>
            <div class="flow-path-item-title">签约合同</div>
          </div>
          <div class="flow-path-item">
            <div class="flow-path-icon icon4">
              <div class="flow-path-item-circle">
                <div class="circle-off"></div>
                <div class="circle-on"></div>
              </div>
            </div>
            <div class="flow-path-item-title">提供文档</div>
          </div>
          <div class="flow-path-item">
            <div class="flow-path-icon icon5">
              <div class="flow-path-item-circle">
                <div class="circle-off"></div>
                <div class="circle-on"></div>
              </div>
            </div>
            <div class="flow-path-item-title">技术对接</div>
          </div>
          <div class="flow-path-line"></div>
        </div>
      </div>
      <div class="account-apply" ref="accountApply">
        <sectionTitle align="space-between" color="black"
                      style="margin-bottom: 60px">
          <template #primary>申请测试账号</template>
          <template #minor>Account apply</template>
          <template #rightText>Account</template>
        </sectionTitle>
        <div class="account-apply-content">
          <div class="title">您的信息将会完全保密，请放心填写：</div>
          <el-form
            :rules="rules"
            :model="form"
            ref="form"
            class="form"
                   label-position="left"
                   label-width="82px">
            <el-form-item label="企业名称:" prop="companyName">
              <el-input class="input" v-model="form.companyName" placeholder="请留下您的公司名称（必填）"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" style="margin-left: 27px" prop="contactPhone">
              <el-input class="input" v-model="form.contactPhone" placeholder="请留下您的联系电话（必填）"></el-input>
            </el-form-item>
            <div class="action-btn" @click="apply">立即申请</div>
          </el-form>
          <div class="contact-desc">
            或者您可以直接联系我们的全国统一技术顾问，联系电话：
            <span>18002570522</span>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import sectionTitle from './../components/sectionTitle/sectionTitle'
import { saveIndexComInfo } from 'api/common'
import { patternTel } from '@/utils/validate'

export default {
  components: { sectionTitle },
  name: 'openPlatform',
  data () {
    return {
      selectSolutionsIndex: 0,
      sectionService: 1,
      industrySolutionsList: [
        {
          title: '电商行业',
          imgUrl: require('./images/bg-case-1.png'),
          question: '某知名社区团购企业，拥有大量的自由职业者为整个供应链服务，其中包括司机、搬运、推广、各社区团长等各种岗位，客户自己拥有成熟的ERP系统来完成日常管理工作。',
          answer: '客户通过API对接，不仅成功推进灵活用工业务，解决了各社区团长的发佣问题，还顺利与其自有系统完成了数据对接，轻松在自有系统中管理所有业务数据，提升自有系统效能。'
        },
        {
          title: '地产行业',
          imgUrl: require('./images/bg-case-2.png'),
          question: '某知名地产企业，每逢新楼盘开盘之际会需要大量的自由置业顾问协助完成楼盘的销售推广，该企业有成熟的CRM和ERP系统，希望可以在解决自由置业顾问的发佣问题的同时同步数据到自有系统中。',
          answer: '客户通过API对接，不仅成功推进灵活用工业务，解决了各自由置业顾问的发佣问题，还顺利与其自有系统完成了数据对接，轻松在自有系统中管理所有业务数据，提升自有系统效能。'
        },
        {
          title: '法律行业',
          imgUrl: require('./images/bg-case-3.png'),
          question: '某知名律所公司由于业务咨询量阶段性变化大，将部分咨询业务外包给自由职业律师。希望在解决自由职业律师发佣问题的同时还能给到自由职业律师专业的用户体验，增强用户的信任。',
          answer: '客户通过API对接，不仅成功推进灵活用工业务，解决了自有职业律所的发佣问题，还顺利与其自有职业律师使用的C端软件完成了数据对接，提升了用户体验，还体现了律所的专业性。'
        },
        {
          title: '教育行业',
          imgUrl: require('./images/bg-case-4.png'),
          question: '某知名教育培训机构，由于寒暑假期网课培训讲师需求量大且聘请全职讲师成本高，与部分自有职业讲师在寒暑假期间进行合作。希望在合规解决自由讲师发佣问题的基础上还能同步数据到自有系统中。',
          answer: '客户通过API对接，不仅成功推进灵活用工业务，解决了各自有职业律所的发佣问题，还顺利与其自有系统完成了数据对接，轻松在自有系统中管理所有业务数据，提升自有系统效能。'
        },
        {
          title: 'SaaS平台',
          imgUrl: require('./images/bg-case-5.png'),
          question: '某知名渠道SaaS平台拥有大量的B端企业客户，随着B端需求的变化，希望能为客户提供更多的服务，以增强客户粘性，更深层次的挖掘客户价值。',
          answer: '该客户通过API对接，接入了我司的灵活用工业务，并与其自有系统完成数据对接。不仅为B端客户提供了新的服务，提升了自身的核心竞争力，还可轻松在自有系统管理所有客户数据，大大提升了管理效能。'
        }
      ],
      topUrl: require('./images/top-bg.png'),
      rules: {
        companyName: [
          { pattern: /^\S+(\s+\S+)*$/, message: '请去除前后空格', trigger: 'blur' },
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { pattern: patternTel, message: '请输入正确的联系人电话', trigger: 'blur' }
        ]
      },
      form: {
        companyName: '',
        contactPhone: '',
        consultType: 6 // api开放
      }
    }
  },
  methods: {
    selectItemHandle(index) {
      this.selectSolutionsIndex = index
    },
    mousemove(key, val) {
      this[key] = val
    },
    scrollToApply() {
      window.scrollTo({ behavior: 'smooth', top: this.$refs.accountApply.offsetTop })
    },
    apply() {
      this.$refs.form.validate((valid, invalidFields) => {
        if (!valid) {
          this.$message.warning(Object.values(invalidFields)[0][0].message)
          return
        }
        saveIndexComInfo(this.form).then(() => {
          this.form = this.$options.data().form
          this.$message({
            message: '信息提交成功，专属客服将尽快联系您，请保持手机畅通！',
            type: 'success'
          })
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "index";
</style>
